import { render, staticRenderFns } from "./classification.vue?vue&type=template&id=751a73b0&scoped=true"
import script from "./classification.vue?vue&type=script&lang=js"
export * from "./classification.vue?vue&type=script&lang=js"
import style0 from "./classification.vue?vue&type=style&index=0&id=751a73b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751a73b0",
  null
  
)

export default component.exports